//for action and buttons both
export default {
    action_0:{
        en:'View',
        bn:'দেখা'
    }, 
    action_1:{
        en:'Add',
        bn:'যোগ'
    },
    action_2:{
        en:'Edit',
        bn:'সম্পাদন'
    },
    action_3:{
        en:'Delete',
        bn:'মুছে ফেলা'
    },
    action_4:{
        en:'Print',
        bn:'ছাপান'
    },
    action_5:{
        en:'CSV',
        bn:'সিএসভি'
    },
    action_6:{
        en:'Search',
        bn:'অনুসন্ধান'
    },
    action_7:{
        en:'Upload',
        bn:'অগ্রবর্তী'
    },
    action_8:{
        en:'Column Control',
        bn:'কলাম নিয়ন্ত্রণ'
    },
    action_short_0:{
        en:'View',
        bn:'দেখা'
    },
    action_short_1:{
        en:'Add',
        bn:'যোগ'
    },
    action_short_2:{
        en:'Edit',
        bn:'সম্পাদন'
    },
    action_short_3:{
        en:'Del',
        bn:'মুছে ফেলা'
    },
    action_short_4:{
        en:'ptr',
        bn:'ছাপান'
    },
    action_short_5:{
        en:'CSV',
        bn:'সিএসভি'
    },
    action_short_6:{
        en:'Src',
        bn:'অনুসন্ধান'
    },
    action_short_7:{
        en:'Up',
        bn:'অগ্রবর্তী'
    },
    action_short_8:{
        en:'CC',
        bn:'কলাম নিয়ন্ত্রণ'
    },
    action_show_in_new_window:{
        en:'Show In new Window',
        bn:'কলাম নিয়ন্ত্রণ'
    },
}
